module.exports = __webpack_public_path__ + "static/media/Right_new2.6bc6a55e.jpg";